import { FC } from 'react'

import { Auth, AuthProps } from './Auth'

export const AppContent: FC<AuthProps> = ({ children, ...props }) => (
  <Auth {...props}>{children || null}</Auth>
)
